import { atom } from "jotai";
import { FundCalendar } from "@/types";

/**
 * Atom for storing fund calendar state in the application
 */
export const FundCalendarStateAtom = atom<FundCalendar[]>([]);

/**
 * Atom for storing the currently selected fund calendar
 */
export const SelectedFundCalendarAtom = atom<FundCalendar | null>(null);
